export class CandidateNotFoundException extends Error {
  constructor(message = 'Candidate not found') {
    super(message);
  }
}
